module.exports = __webpack_public_path__ + "media/zillow-plaid.f3673666.svg";